// removed by extract-text-webpack-plugin
module.exports = {"right":"right___3rqku","sum":"sum___rwe0r"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Total.scss
// module id = 24
// module chunks = 0